import _ from "lodash";
import RequestError from "./RequestError";
import amProxyUrl from "./AmProxyUrl";
import api from "@/api";

/**
 * @typedef RequestConfig
 * @prop {string} path
 * @prop {string} method
 * @prop {Object} [params]
 * @prop {any} [data]
 */

export default {
  getDestinations,
  createDestination,
  getPlatformIcon,
  updateAccessList,
  getAccessList,
  verifyGuestEmail,
  verifyGuestUrl,
};

function getDestinations(id) {
  return makeRequest({
    path: "/guest-destinations/" + id,
    method: "get",
  });
}

/**
 * @param {object} destination
 */
async function createDestination(destination) {
  return makeRequest({
    path: "/guest/add-destinations",
    method: "post",
    data: destination,
  });
}

/**
 * @param {object} destination
 */
async function updateAccessList(id, users) {
  return makeRequest({
    path: "/guest-destinations/users/" + id,
    method: "post",
    data: users,
  });
}

function getAccessList(id) {
  return makeRequest({
    path: "/guest-destinations/users/" + id,
    method: "get",
  });
}


function verifyGuestEmail(data) {
  return makeRequest({
    path: "/guest/verify-email",
    method: "post",
    data: data,
  });
}

function verifyGuestUrl(data) {
  return makeRequest({
    path: "/guest/verify-url",
    method: "post",
    data: data,
  });
}

/**
 * @param {string} id
 * @param {string} name
 * @param {string} server
 * @param {number} key
 * @param {object} port
 * @param {string} latency
 * @param {string} passphrase
 */
async function updateDestination(
  id,
  name,
  server,
  key,
  port,
  latency,
  passphrase
) {
  return makeRequest({
    path: `/destinations/${id}`,
    method: "patch",
    data: {
      name,
      server,
      key,
      port,
      latency,
      passphrase,
    },
  });
}

/**
 * @param {string} destinationId
 * @param {string} streamId
 */
async function addDestinationToStream(destinationId, streamId) {
  return makeRequest({
    path: `/destinations/${destinationId}/streams/${streamId}`,
    method: "post",
  });
}

/**
 * @param {string} destinationId
 * @param {string} streamId
 */
async function removeDestinationFromStream(destinationId, streamId) {
  return makeRequest({
    path: `/destinations/${destinationId}/streams/${streamId}`,
    method: "delete",
  });
}

/**
 * @param {string} id
 */
async function deleteDestination(id) {
  return makeRequest({
    path: `/destinations/${id}`,
    method: "delete",
  });
}

/**
 * @param {RequestConfig|string} reqConfig
 */
async function makeRequest(reqConfig, preventProxy, throwReal) {
  if (typeof reqConfig === "string") {
    reqConfig = {
      path: reqConfig,
    };
  }

  if (preventProxy !== true) {
    reqConfig = amProxyUrl(reqConfig, process.env.VUE_APP_VOD_API_BASE_URL);
  }

  reqConfig.url = reqConfig.path;

  let res;
  try {
    res = await api.request(reqConfig);
  } catch (err) {
    if (throwReal) {
      throw err;
    }
    const edata = _.get(err, "response.data");
    throw new RequestError(edata);
  }

  return res && res.data;
}

const platforms = [
  {
    name: "youtube",

    icon: "youtube.svg",
    serverKeySegments: [
      { text: "rtmp://", hidden: true },
      { input: true, placeholder: "x", width: 50 },
      ".rtmp.youtube.com",
      { text: "/live2", hidden: false },
    ],
    serverKeySegmentValues: [],
    canLinkService: true,
    serviceAuthorization: {
      enabled: true,
      metadata: {
        fields: [
          { key: "title", required: true },
          // { key: 'description', disabled: true, value: 'Multistreaming with Castr.io' }
          { key: "description", value: "Multistreaming with Castr.io" },
        ],
      },
    },
  },
  {
    name: "youtube events",

    icon: "youtube.svg",
  },
  {
    name: "twitch",

    icon: "twitch.svg",
    canLinkService: true,
    serviceAuthorization: {
      enabled: true,
      metadata: {
        fields: [{ key: "title", required: true }, { key: "game" }],
      },
    },
  },
  // { name: 'facebook live',  icon: 'facebook-live.svg' },
  {
    name: "facebook live",
    //   customServer: true,
    // serverKeySegments: [
    //   { input: true, placeholder: 'rtmp://facebook-rtmp-server-addr:80/rtmp/' },
    // ],
    // serverKeySegmentValues: [],
    serverInputPlaceholder: "rtmp://facebook-rtmp-server-addr:80/rtmp/",
    icon: "facebook-live.svg",
  },
  { name: "Vimeo", icon: "vimeo.svg" },
  {
    name: "periscope",
    serverKeySegments: [
      { text: "rtmp://", hidden: true },
      { input: true, placeholder: "ca", width: 40 },
      ".pscp.tv:80/",
      { input: true, placeholder: "x/0", width: 40 },
    ],
    serverKeySegmentValues: [],
    icon: "periscope.png",
  },
  {
    name: "mixer",

    icon: "mixer.svg",
    canLinkService: true,
    serviceAuthorization: {
      metadata: {
        fields: [
          { key: "title", required: true },
          // { key: 'description', disabled: true, value: 'Multistreaming with Castr.io' }
          { key: "description", value: "Multistreaming with Castr.io" },
        ],
      },
    },
  },
  {
    name: "steam",

    // serverKeySegments: [
    //   { text: 'rtmp://', hidden: true },
    //   { input: true, placeholder: 'br4-lhr1', width: 80 },
    //   '.broadcast.steamcontent.com',
    //   { text: '/app', hidden: true }
    // ],
    // serverKeySegmentValues: [],
    icon: "steam.png",
    streamKeyPlaceholder: "steam_852695447_c3886cec1233395a",
  },
  { name: "mobcrush", icon: "mobcrush.svg" },
  {
    name: "dlive",

    streamKeyPlaceholder: "aq6U8I3Osok9d05ExWeCZ12AGy7nsjl_password",
    icon: "dlive.png",
  },
  {
    name: "Nimo TV",

    streamKeyPlaceholder:
      "zu9759512055689r26ec0fbb2ed70800aad9c8e316783pm29j78fosd==&ws2al=1&ws2tx=1",
    icon: "nimotv.png",
  },
  {
    name: "USTREAM",
    serverKeySegments: [
      { text: "rtmp://", hidden: true },
      { input: true, placeholder: "----", width: 60 },
      { text: "...ustream.tv/ustreamVideo/", exclude: true },
      { text: ".fme.ustream.tv/ustreamVideo/", hidden: true },
      { input: true, placeholder: "----", width: 60 },
      { text: "/", hidden: true },
    ],
    serverKeySegmentValues: [],
    icon: "ustream.svg",
  },
  {
    name: "VK Live",
    customServer: true,
    serverInputPlaceholder: "rtmp://vsu.mycdn.me/input",
    streamKeyPlaceholder: "tP43J7523M_zp",
    icon: "vk.png",
  },
  { name: "Vimm.tv", icon: "vimmtv.png", streamKeyPlaceholder: "stream-key" },
  {
    name: "GoodGame",
    icon: "gg.svg",
    streamKeyPlaceholder: "30549?pwd=000a0000b00000b0",
  },
  {
    name: "cybergame",
    icon: "cybergame.svg",
    streamKeyPlaceholder: "example?key=tJz0m0XRsZZktYOuv",
  },
  { name: "StreamMe", icon: "streamme.svg" },
  {
    name: "bilibili",
    icon: "bilibili.svg",
    streamKeyPlaceholder: "streamname=live_..&key=...",
  },
  {
    name: "picarto TV",
    icon: "picartotv.svg",
    streamKeyPlaceholder: "ptv_125095_01115ae8b3cd",
  },
  { name: "web TV", icon: "webtv.png" },
  // {
  //   name: 'GamePlank',
  //
  //   streamKeyPlaceholder: 'GamePlank_xxxxxxxxxxxxxxxxxxxxxxx',
  //   icon: 'gameplank.png'
  // },
  { name: "vaughn live", icon: "vaughnlive.svg" },
  { name: "breakers TV", icon: "breakerstv.svg" },
  { name: "instagib", icon: "instagib.svg" },
  { name: "vapers TV", icon: "vaperstv.svg" },
  { name: "DJlive.pl", icon: "djlive.png" },
  { name: "Boomstream", icon: "boomstream.png" },
  { name: "StreamLive", icon: "stream-logo-light.png" },
  { name: "Medirix Live Sports", icon: "medirix.png" },
  { name: "Livestream", icon: "livestream.png" },
  { name: "LiveEdu TV", icon: "liveedu.svg" },
  { name: "Switchboard Live", icon: "switchboard.png" },
  { name: "Cavetube", icon: "cavetube.svg" },
  { name: "Livehouse", icon: "livehouse.svg" },
  { name: "Younow", icon: "now.svg" },
  { name: "FC2Live", icon: "fc2.svg" },
  { name: "lahzenegar", icon: "lahzenegar.png" },
  { name: "wasd", icon: "wasd.svg" },
  { name: "Theta.tv", icon: "thetatv.png" },
  { name: "Trovo", icon: "trovo.png" },
  { name: "Mixcloud", icon: "mixcloud.svg" },
  { name: "LinkedIn", icon: "linkedin.svg" },
  { name: "Twitter", icon: "twitter.svg" },
  { name: "Meridix Live Sports", icon: "meridix.svg" },
  { name: "SportsCastr", icon: "sportscastr.svg" },
  { name: "PhoneLiveStreaming", icon: "phonelivestreaming.svg" },
  { name: "custom", icon: "custom.svg" },
];

function getPlatformIcon(name) {
  const platform = _.find(platforms, (p) =>
    new RegExp("^" + p.name + "$", "gi").test(name)
  );
  return platform && platform.icon;
}
